// ©2024 Austin App House. All rights reserved.
import React from "react";
import {components} from "react-select";

const CustomMultiValueLabelShort = ({ children, ...props }) => {
    const fixedLabelLength = children.length <= 10 ? children  : children.substr(0, 7)+'...'
    return (
        <components.MultiValueLabel {...props} >
            {fixedLabelLength}
        </components.MultiValueLabel>
    );
}

export default CustomMultiValueLabelShort